
export const useContainerStyles = {
    root: {
        width: "calc(100% - 70px)",
        margin: "0 auto"
    },
    userScreenRoot: {
       // width: "calc(100% - 100px)",
       // margin: "100px auto"
    }
};